import React from 'react';
import Link from 'next/link';

interface ButtonProps {
    href: string;
    textForButton: string;
    icon?: React.ReactNode; 
    className?: string;
}

const OurButton: React.FC<ButtonProps> = ({ href, textForButton, icon, className }) => {
    if (!textForButton) {
        return null;
    }

    return (
        <Link
            className={`w-fit flex justify-end items-center gap-2.5 py-2 px-5 rounded-full border border-blue-500 text-blue-500 bg-blue-50 hover:bg-blue-500 hover:text-white transition duration-300 ${className}`}
            href={href}
        >
            {textForButton}
            {icon && <span>{icon}</span>}
        </Link> 
    );
};

export default OurButton;
